import {
  DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_BEGIN,
  DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_SUCCESS,
  DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_FAILURE,
  DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function getSchemaForXataCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xata/get-schema`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_FAILURE,
            data: { error: err },
          });
          const errMsg = err.response ? err.response.data.message : `Check Table or region Name`;
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetSchemaForXataCollectionError() {
  return {
    type: DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_BEGIN:
      return {
        ...state,
        getSchemaForXataCollectionPending: true,
        getSchemaForXataCollectionError: null,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_SUCCESS:
      return {
        ...state,
        getSchemaForXataCollectionPending: false,
        getSchemaForXataCollectionError: null,
        schemaForXata: action.data,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_FAILURE:
      return {
        ...state,
        getSchemaForXataCollectionPending: false,
        getSchemaForXataCollectionError: action.data.error,
      };

    case DATA_CONNECTOR_GET_SCHEMA_FOR_XATA_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        getSchemaForXataCollectionError: null,
      };

    default:
      return state;
  }
}
